<div [formGroup]="formGroup()" class="grid grid-cols-1 md:grid-cols-2 gap-3">
  <siat-datepicker-field
    [formGroup]="formGroup()"
    controlName="dateStart"
    [label]="dateLabel()"
    [placeholder]="dateLabel()"
    class="col-span-1"
    [minDate]="minDate()"
    [dateFilter]="holidayFilter"
  ></siat-datepicker-field>
  <div class="col-span-1">
    <siat-timepicker-field
      [formGroup]="formGroup()"
      controlName="time"
      initialScrollTime="07:00"
      [minTime]="minTimeInizio()"
      [maxTime]="maxTimeInizio()"
      [label]="timeLabel() ?? ('FIELDS.ORARIO.label' | translate)"
      [hint]="fineHint()"
    ></siat-timepicker-field>
  </div>
  @if (withEnd()) {
    <siat-datepicker-field
      [formGroup]="formGroup()"
      controlName="dateEnd"
      label="Data fine"
      placeholder="Data fine"
      class="col-span-1"
      [minDate]="minDate()"
      [dateFilter]="holidayFilter"
    ></siat-datepicker-field>
    <div class="col-span-1">
      <siat-timepicker-field
        [formGroup]="formGroup()"
        controlName="timeEnd"
        label="Ora fine"
        initialScrollTime="07:00"
        [minTime]="minTimeFine()"
        [maxTime]="maxTimeFascia()"
      ></siat-timepicker-field>
    </div>
    @if (formGroup().hasError('fineNonSuccessiva')) {
      <div class="text-danger text-sm col-span-1 md:col-span-2 -mt-2">
        La fine non può essere precedente all'inizio.
      </div>
    }
  }
  @if (formGroup().getError('fineOltreChiusura'); as errore) {
    <div class="text-danger text-sm col-span-1 md:col-span-2 -mt-2">
      L'appuntamento termina dopo la chiusura della struttura ({{
        errore.chiusura
      }}).
    </div>
  }
  @if (
    formGroup().hasError('dateTimeInPast') &&
    (formGroup().touched || formGroup().dirty)
  ) {
    <div class="text-danger text-sm col-span-1 md:col-span-2 -mt-2">
      L'data e l'orario selezionati non possono essere antecedenti a quelli
      attuali.
    </div>
  }
</div>
